import { render, staticRenderFns } from "./yachts_book.vue?vue&type=template&id=5f88db27&scoped=true&"
import script from "./yachts_book.vue?vue&type=script&lang=js&"
export * from "./yachts_book.vue?vue&type=script&lang=js&"
import style0 from "@/styles/super.css?vue&type=style&index=0&id=5f88db27&prod&scoped=true&lang=css&"
import style1 from "./yachts_book.vue?vue&type=style&index=1&id=5f88db27&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f88db27",
  null
  
)

export default component.exports